import {
  RP_SHIFT_MODEL_LIST,
  RP_SHIFT_PAGINATION,
  RP_SHIFT_SEARCH,
} from "./actionType";


import moment from 'moment';

const toGasDate = moment().add(-1, 'day');

const initialState = {
  modelDeviceList: [],
  modelSearch: { SHIFT_DAILY: moment(new Date(toGasDate.year(), 0, 1)), TO_SHIFT_DAILY: moment(new Date(toGasDate.year(), 11, 31)), },
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RP_SHIFT_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case RP_SHIFT_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case RP_SHIFT_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    default:
      return state;
  }
};
